import { render, staticRenderFns } from "./Metamask.vue?vue&type=template&id=9b643a5c&scoped=true&"
import script from "./Metamask.vue?vue&type=script&lang=js&"
export * from "./Metamask.vue?vue&type=script&lang=js&"
import style0 from "./Metamask.vue?vue&type=style&index=0&id=9b643a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b643a5c",
  null
  
)

export default component.exports